import { createContext } from 'maverick.js';

// src/player/ui/sliders/slider/format.ts
var sliderValueFormatContext = createContext(() => ({}));

export { sliderValueFormatContext };
